import {
  ADULTWORK_URL,
  MINTSTARS_URL,
  CLIPS4SALE_URL,
  SUBMISSIONSUITE_URL,
  BADKITY_URL,
  DOMMELINK_URL,
  DOMMELINE_URL,
  ALLMYLINKS_URL,
  BLUESKY_URL,
} from '../../utils/Constants';
// Images
import MintLogo from '../../assets/images/logos/mint-stars-logo.png';
import DommeLinkLogo from '../../assets/images/logos/domme-link-logo.png';
// Icons
import { FaFan } from 'react-icons/fa6';
import { SiFandango } from 'react-icons/si';
import { FaTelegramPlane } from 'react-icons/fa';
import { MdOutlinePhoneIphone } from 'react-icons/md';
import { FaCat } from 'react-icons/fa6';
import { FaFistRaised } from 'react-icons/fa';
import { FaBoltLightning } from "react-icons/fa6";
import { FaBluesky } from "react-icons/fa6";

export const linkButtonArray = [
  {
    text: 'AdultWork',
    link: ADULTWORK_URL,
    icon: (
      <>
        <span className='text-xs'>AW</span>
      </>
    ),
  },
  { text: 'MintStars', link: MINTSTARS_URL, image: MintLogo },
  { text: 'Clips4Sale', link: CLIPS4SALE_URL, icon: <FaBoltLightning /> },
  { text: 'Submission Suite', link: SUBMISSIONSUITE_URL, icon: <FaFistRaised /> },
  { text: 'BlueSky', link: BLUESKY_URL, icon: <FaBluesky /> },
  { text: 'BadKity', link: BADKITY_URL, icon: <FaCat /> },
  { text: 'DommeLink', link: DOMMELINK_URL, image: DommeLinkLogo },
  { text: 'Dommeline', link: DOMMELINE_URL, icon: <MdOutlinePhoneIphone /> },
  { text: 'AllMyLinks', link: ALLMYLINKS_URL, icon: <FaTelegramPlane /> },
];
